import * as React from 'react'

interface TabItem {
	key: string
	label: string
	icon?: React.ReactNode
}

interface Props {
	tabs: TabItem[]
	activeTab: string
	onTabSelect: (tabKey: string) => void
	className?: string
}

const CustomTabs = ({ tabs, activeTab, onTabSelect, className = '' }: Props) => {
	return (
		<>
			<style>
				{`
					.custom-tabs {
						border-bottom: 1px solid rgba(3, 53, 66, 0.12);
					}
					
					.custom-tabs-container {
						display: flex;
						align-items: center;
						max-width: 100%;
					}
					
					.custom-tab {
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 8px;
						padding: 9px 16px;
						border: none;
						background: none;
						cursor: pointer;
						font-family: 'ES Allianz', Arial, sans-serif;
						font-size: 14px;
						line-height: 1.71;
						letter-spacing: 0.029em;
						position: relative;
						transition: all 0.2s ease;
						white-space: nowrap;
					}
					
					.custom-tab.active {
						color: #188383;
						font-weight: 400;
						background: transparent;
					}
					
					.custom-tab.active::after {
						content: '';
						position: absolute;
						bottom: -1px;
						left: 0;
						right: 0;
						height: 2px;
						background-color: #188383;
					}
					
					.custom-tab.inactive {
						color: rgba(3, 53, 66, 0.6);
						font-weight: 500;
						background: #F1F6F9;
					}
					
					.custom-tab:hover.inactive {
						color: rgba(3, 53, 66, 0.8);
						background: #E8F0F3;
					}
					
					.custom-tab-icon {
						width: 24px;
						height: 24px;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					
					.custom-tab.active .custom-tab-icon {
						color: rgba(65, 80, 92, 0.56);
					}
					
					.custom-tab.inactive .custom-tab-icon {
						color: rgba(3, 53, 66, 0.6);
					}
				`}
			</style>

			<div className={`custom-tabs ${className}`}>
				<div className="custom-tabs-container">
					{tabs.map((tab) => (
						<button
							key={tab.key}
							className={`custom-tab ${activeTab === tab.key ? 'active' : 'inactive'}`}
							onClick={() => onTabSelect(tab.key)}
						>
							{tab.icon && <div className="custom-tab-icon">{tab.icon}</div>}
							<span>{tab.label}</span>
						</button>
					))}
				</div>
			</div>
		</>
	)
}

export default CustomTabs
